<template>
    <div>
            <!-- En-tête de la liste des référentiels -->
            <div class="action-buttons">
                <button v-if="selectedReferential == 0 && isAdmin" @click="createReferentialModalOpen" class="create-button">Nouveau</button>
                <button v-if="selectedReferential == 0" class="create-button" @click="showArchived = !showArchived">
                    {{ showArchived ? 'Masquer archives' : 'Référentiels archivés' }}
                </button>
                <!-- <button v-if="selectedReferential > 0" @click="exitReferentialView" class="back-button">Retour</button> -->
            </div>
            <div v-if="selectedReferential === 0" class="referential-header">
                
                <!-- <div class="id-col" @click="sortBy('id')">
                    ID <i class="bi bi-filter"></i>
                </div> -->
                <div class="title-col" @click="sortBy('title')">Titre <i class="bi bi-filter"></i></div>
                <div class="description-col">Description</div>
                <div class="status-col" v-if="!showArchived">
                        <select v-model="filters.status" class="header-filter-select">
                            <option v-for="option in statusOptionsToShow"
                            :key="option.value"
                            :value="option.value"
                            >
                            {{ option.label }}
                            </option>
                        </select>
                </div>
                <div class="status-col" v-if="showArchived">
                    &nbsp;
                </div>

                <div class="date-col" @click="sortBy('modification_date')">
                    Créé le <i class="bi bi-filter"></i>
                </div>
                <div class="date-col" @click="sortBy('creation_date')">
                    Modifié le <i class="bi bi-filter"></i>
                </div>
            </div>
            
            <div v-if="selectedReferential > 0 && questionTree.length > 0" class="filterQ">
                <label class="filter-label">
                    <input type="checkbox" v-model="filterIsActive">Afficher uniquement les critères/questions d’exclusion
                </label>
            </div>

            <!-- <div v-if="selectedReferential > 0" class="referential-filter second">
                <div class="title-col">
                    <input type="text" v-model="filters.title" placeholder="Filtrer par titre..." class="filter-input" />
                </div>
                <div class="reference-col">
                    <input type="text" v-model="filters.reference" placeholder="Filtrer par reference..." class="filter-input" />
                </div>
            </div> -->

        <!-- Liste des référentiels -->
        <div v-if="selectedReferential == 0" class="referential-list">
            <div 
                v-for="referential in filteredSortedReferentials" 
                :key="referential.referentiel_id" 
                class="referential-item"
                :class="{ locked: lockedClass(referential.referentiel_id) }"
                :title="referentialStatus(referential.referentiel_id).LOCKED ? 'Verrouillé jusqu\'à ' + formatDate(referential.locked_until) + ' par ' + referential.modified_by_username : ''"
                @click="handleReferentialClick(referential.referentiel_id)"
            >
                <!-- <div class="id-col">{{ referential.referentiel_id }}</div> -->
                <div class="title-col">{{ referential.title }}</div>
                <div class="description-col" :title="referential.site">{{referential.description }}</div>
                <!--<div class="projects-col" v-if="selectedReferential > 0 && getProjectsAfterValidation + getProjectsInValidation > 0" @click.stop="goToProjectValidators">
                    <span class="projects-name">Projet(s)</span>
                    <div v-if="getProjectsInValidation" class="validation"> {{ getProjectsInValidation }} en cours de validation</div>
                    <div v-if="getProjectsAfterValidation" class="validation"> {{ getProjectsAfterValidation }} validé(s) ou archivé(s)</div>
                </div>
                
                 <div class="actions-col" v-if="selectedReferential > 0">
                    <button @click.stop="unlockReferential()" v-if="(referentialStatus(referential.referentiel_id).LOCKED ||referentialStatus(referential.referentiel_id).LOCKED === null) && referentialStatus(referential.referentiel_id).OWNER" class="btn btn-icon"><i class="bi bi-unlock" title="Débloquer référentiel"></i></button>
                    <button @click.stop="addChild()" v-if="!isReferentialLocked(selectedReferential)" class="btn btn-icon"><i class="bi bi-plus" title="Créer critère"></i></button>
                    <button @click.stop="editReferential()" v-if="!isReferentialLocked(selectedReferential)" class="btn btn-icon"><i class="bi bi-pencil-fill" title="Editer"></i></button>
                    <button @click.stop="deleteReferential()" class="btn btn-icon" v-if="isAdmin && referential.status === 'ARCHIVE'" :disabled="isReferentialLocked(selectedReferential)"><i class="bi bi-trash3-fill" title="Effacer"></i></button>
                    <button v-if="!isReferentialLocked(selectedReferential)" @click.prevent="changeReferentialStatus('ARCHIVE')" :disabled="isReferentialLocked(selectedReferential)" class="btn btn-icon"><i class="bi bi-trash3-fill" title="Archiver"></i></button>
                    <button @click.stop="duplicateReferential()" class="btn btn-icon" v-if="isAdmin"><i class="bi bi-copy" title="Dupliquer"></i></button>
                    <button @click.stop="createProject()" class="btn btn-icon"><i class="bi bi-folder-plus" title="Créer projet à partir du referentiel"></i></button>
                    <button @click.stop="analyzeReferential()" class="btn btn-icon"><i class="bi bi-check-circle-fill" title="Analyse du référentiel"></i></button>
                </div> -->
                <div v-if="selectedReferential === 0" class="status-col">
                    {{ getStatusLabel(referential) }}
                    <span v-if="referentialStatus(referential.referentiel_id).LOCKED">
                        &nbsp;&nbsp;<i class="bi bi-lock-fill"></i>
                    </span>
                </div>
                <div v-if="selectedReferential == 0" class="date1-col" :title= "referential.created_by_username" >{{ formatDate(referential.creation_date) }}</div>
                <div v-if="selectedReferential == 0" class="date2-col" :title= "referential.modified_by_username" >{{ formatDate(referential.modification_date) }}</div>
            </div>
        </div>
        
        <!-- Vue détaillée d'un référentiel avec structure de critères -->
        <div v-if="selectedReferential" class="criteria-container">
            <ReferentialTreeEditor 
                v-bind:children="fetchRootCriteria(selectedReferential)" 
                v-bind:level=0
                :filter-is-active="filterIsActive">
            </ReferentialTreeEditor>
        </div>
        
        <!-- Boutons d'action -->
        <!-- <div class="action-buttons">
            <button v-if="selectedReferential > 0" @click="exitReferentialView" class="back-button">Retour</button>
            <button v-if="selectedReferential == 0 && isAdmin" @click="createReferentialModalOpen" class="create-button">Nouveau</button>
        </div> -->
        
        <!-- Composants modaux -->
        <ConfirmationDialog v-if="canEditList.confirmationDialogOpen" />
        <ReferentialModalCreator v-if="canEditList.referentialCreatorOpen"/>
        <CriteriaModalEditor v-if="selectedReferential > 0 && canEditList.criteriaEditorOpen"/>
        <QuestionModalEditor v-if="selectedReferential > 0 && canEditList.questionEditorOpen" :key="activeQuestion ? activeQuestion.id : 'new-question'"/>
        <ProjectModalCreator v-if="canEditList.projectModalOpen"/>
        </div>
    <ConfirmationDialog v-if="canEditList.confirmationDialogOpen" />
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ReferentialTreeEditor from './ReferentialTreeEditor.vue'
import ReferentialModalCreator from './ReferentialModalCreator.vue'
import CriteriaModalEditor from './CriteriaModalEditor.vue';
import QuestionModalEditor from './QuestionModalEditor.vue';
import ConfirmationDialog from '../generic/ConfirmationDialog.vue';
import '../../assets/styles/base.css';
import '../../assets/styles/multiselect.css';
import ProjectModalCreator from '../project/ProjectModalCreator.vue';

export default {
    name: "ReferentialEditor",

    components: {
        ReferentialTreeEditor,
        ReferentialModalCreator,
        CriteriaModalEditor,
        QuestionModalEditor,
        ConfirmationDialog,
        ProjectModalCreator,
    },
    data() {
        return {
            filters: {
                title: "",
                status: "",
                reference: ""
            },
            statusOptions:[
                {value:"", label:"Status"},
                {value:"EDITING", label:"Edition"},
                {value:"RELEASE", label:"Production"},
                {value:"RELEASEUSED", label: "Production (utilisé)"},
                {value:"ARCHIVE", label:"Archivé"}
            ],
            sortField: "id",
            sortDirection: "asc",
            showFilters: false,
            /* translationArray: {
                "": "Tout les status",
                "EDITING": "Edition",
                "RELEASE": "Production",
                "ARCHIVE": "Archivé"
            }, */
            filterIsActive: false,
            showArchived: false,
            /* referentialLoading: true, */
            initialDataLoaded: false,
        }
    },
    computed: {
        ...mapState("referential", ["referentialData", "selectedReferential", "criteriaTree", "questionTree", "canEditList", "loading", "numberProjects", "activeQuestion", "referentialErrors", "unlockStatus", "projectStatusByReferential"]),
        ...mapState("project", ["projectData", "roles"]),
        ...mapState("auth", ["user_id", "isAdmin"]),
        ...mapGetters("referential", ["fetchRootCriteria", "isReferentialLocked", "getReferentialStatus", "formatDate", "referentialLoaded", "getProjectsInValidation", "filterActiveReferential", "lockedClass"]),
        
        baseFilteredReferentialData() {
            return this.referentialData.filter(
                ref => this.selectedReferential === 0 || this.selectedReferential == ref.referentiel_id
            );
        },
        statusOptionsToShow(){
            if(!this.showArchived){
                //console.log("!this.showArchived, HERE'S YOUR STATUSOPTIONS :", this.statusOptions)
                return this.statusOptions.filter(opt => opt.value !== 'ARCHIVE');
            }else{
                this.filters.status === 'ARCHIVE';
                return this.statusOptions.filter(opt => opt.value === 'ARCHIVE');
            }
        },       
        filteredSortedReferentials() {
            let filtered = this.baseFilteredReferentialData;
            //console.log("this.baseFilteredReferentialData",this.baseFilteredReferentialData)
            if(this.showArchived) {
                filtered = filtered.filter(ref => ref.status === 'ARCHIVE');
                //console.log ("filtered : ",filtered)
            } else {
                filtered = filtered.filter(ref => ref.status !== 'ARCHIVE');
            }

            if (this.filters.title) {
                filtered = filtered.filter(ref => 
                    ref.title.toLowerCase().includes(this.filters.title.toLowerCase())
                );
            }
            
            if (this.filters.status) {
                filtered = filtered.filter(ref => 
                    ref.status === this.filters.status
                );
            }
                
            return [...filtered].sort((a, b) => {
                switch (this.sortField) {
                    case "id":
                        return this.sortDirection === "asc" 
                            ? a.referentiel_id - b.referentiel_id
                            : b.referentiel_id - a.referentiel_id;
                    case "title":
                        return this.sortDirection === "asc"
                            ? a.title.localeCompare(b.title)
                            : b.title.localeCompare(a.title);
                    case "status":
                        return this.sortDirection === "asc"
                            ? a.status.localeCompare(b.status)
                            : b.status.localeCompare(a.status);
                    case "modification_date":
                        return this.sortDirection === "asc"
                            ? new Date(a.modification_date) - new Date(b.modification_date)
                            : new Date(b.modification_date) - new Date(a.modification_date);
                    case "creation_date":
                        return this.sortDirection === "asc"
                            ? new Date(a.creation_date) - new Date(b.creation_date)
                            : new Date(b.creation_date) - new Date(a.creation_date);
                    default:
                        return a.referentiel_id - b.referentiel_id;
                }
            });
        }
    },
    async mounted() {
        this.$store.commit("referential/loadingMutation", true);
        await this.$store.dispatch("referential/fetchReferentialList")
            .catch(error => console.error("Err:", error))
            await this.$store.dispatch("referential/projectStatus", {id : this.selectedReferential}); 
            if (this.isAdmin) {
            //console.log("Admin user detected on mount, fetching all project statuses for the list.");
        }
        this.checkRouteParams()
        this.$store.commit("referential/loadingMutation", false);
        //console.log("Referential status by referential", this.projectStatusByReferential)
        this.$store.commit("project/selectProjectMutation", 0)
    },
    watch: {
        '$route.params.id': 'checkRouteParams',
        showArchived(){
                if(this.showArchived && this.filters.status !== "ARCHIVE")return this.filters.status = 'ARCHIVE';
                else return this.filters.status = ''
        },
        isAdmin: {
            async handler(isNowAdmin) {
                if (isNowAdmin && !this.initialDataLoaded) {
                    this.initialDataLoaded = true;
                    this.$store.commit("referential/loadingMutation", true);
                    await this.$store.dispatch("referential/fetchReferentialList");
                    //console.log("Statut Admin confirmé, chargement des statuts de tous les projets. ");
                    
                    //What's the purpose of geting the project infos for all the referential you have access to ?

                    /* const promises = this.referentialData.map(ref =>  */
                    if(this.selectedReferential > 0 || !isNaN(this.selectedReferential))
                    this.$store.dispatch("referential/projectStatus", { id: this.selectedReferential/* ref.referentiel_id  */})
                /* );
                    await Promise.all(promises); */
                    this.$store.commit("referential/loadingMutation", false);
                }
            },
            immediate: true
        },
        selectedReferential() {
        this.$store.commit('referential/unlockStatus', false);
    }
    },
    methods: {
        AmountOfProject(referentialId){
            if (!this.projectData || this.projectData.length === 0) {
                return 0;
            }
            return this.projectData.filter(project => project.referential_id === referentialId).length;
        },

        sortBy(field) {
            if (this.sortField === field) {
                // Inverser la direction du tri si on clique sur le même champ
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                // Nouveau champ de tri, par défaut ascendant
                this.sortField = field;
                this.sortDirection = 'asc';
            }
        },
        toggleFilterView() {
            this.showFilters = !this.showFilters;
        },
        checkRouteParams() {
            //console.log("Route params found, setting selectedReferential to:", this.$route)
            if(this.$route.params.id) {
                //console.log("Route params found, setting selectedReferential to:", this.$route.params.id)
                this.$store.dispatch("referential/fetchCriteriaListFromReferential", { id: this.$route.params.id})
                //console.log("Is it an admin user?", this.isAdmin)
                
                // if(this.isAdmin){
                //     //console.log("Admin user, fetching project status")
                    // this.$store.dispatch("referential/projectStatus", {id: this.$route.params.id})
                // }
            } else {
                this.$store.commit("referential/selectTreeMutation", 0)
            }   
        },

        async handleReferentialClick(id) {
            //console.log("locked_", this.getReferentialStatus(id))
            if (this.loading) return;
            try {
                this.$store.commit("referential/loadingMutation", true);
            
                if (this.selectedReferential === id) {
                    this.exitReferentialView();
                } else {
                    await this.$store.dispatch("referential/fetchCriteriaListFromReferential", { id: id});
                    this.$store.commit("referential/selectTreeMutation", id);
                    this.$router.push('/referential/'+id);
                    this.$store.dispatch("project/fetchProjectList")
                }
            } catch (error) {
                console.error("Erreur :", error);
            } finally {
                this.$store.commit("referential/loadingMutation", false);
            }
        },
        /* resetFilters() {
            this.filters.title = "";
            this.filters.status = "";
            this.sortField = "id";
            this.sortDirection = "asc";
            //this.$router.push('/referential');
        },
        exitReferentialView() {
            this.$store.commit("referential/selectTreeMutation", 0)
            this.$router.push('/referential')
            this.resetFilters();
        }, */
        createReferentialModalOpen() {
            if(this.selectedReferential == 0) {
                this.$store.commit("referential/toggleReferenentialModalNew", true)
            } 
        },
        createReferentialModalClose() {
            if(this.selectedReferential == 0) {
                this.$store.commit("referential/toggleReferenentialModalNew", false)
            }
        },
        editReferential() {
            this.$store.commit("referential/toggleReferenentialModalNew", true)
        },
        addChild() {
            let rootCriteria = this.fetchRootCriteria(this.selectedReferential)
            this.$store.commit("referential/makeCriteriaActiveMutation", [])
            this.$store.commit("referential/callerSetMutation", rootCriteria)
            this.$store.commit("referential/toggleCriteriaModal", !this.canEditList.criteriaEditorOpen)
        },
        /* deleteReferential() {
            this.$store.commit("referential/returnConfirmationObjectMutation", { 
                id: this.selectedReferential, 
                type: "delete-referential",
                title: "Suppression",
                message: "Êtes-vous sûr de vouloir supprimer ce référentiel?"
            })
        }, */
        
        async duplicateReferential() {
            this.$store.commit("referential/returnConfirmationObjectMutation", { 
                id: this.selectedReferential, 
                type: "duplicate-referential",
                title: "Duplication",
                message: "Êtes-vous sûr de vouloir dupliquer ce référentiel?"
            })
        },
        /* async analyzeReferential(){
            await this.$store.dispatch("referential/referentialValidate", {
                id: this.selectedReferential
            })
            let title = ""
            let message = ""
            const hasBlockingError = this.referentialErrors.some(error => error.status === 'ERREUR');
            const hasErrors = this.referentialErrors && this.referentialErrors.length > 0;
            title = "Analyse";
                    if (hasErrors) {
                        message = "Le référentiel a des problèmes :<br><br>";
                        for (const error of this.referentialErrors) {
                            message += `<b>Statut:</b> ${error.status}<br>`;
                            message += `<b class="parameters">Paramètre:</b> ${error.parameter}<br>`;
                            message += `<b>Message:</b> ${error.message}<br><br>`;
                        }
                    }else{
                            message = "Aucun problème/information sur ce référentiel"
                        }
                        this.$store.commit("referential/returnConfirmationObjectMutation", { 
                id: this.selectedReferential, 
                type: "referential-analyze-status",
                title: title,
                message: message,
                hasBlockingError: hasBlockingError,
                //newStatus: status,
            })
        },

        changeReferentialStatus(status) {
            let title = ""
            let message = ""
            switch(status) {
                case "VALIDATION":
                    title = "Mise en évaluation"
                    message = "Êtes-vous sûr de vouloir mettre ce projet en évaluation ?<br>L'envoi du rapport pour évaluation vaut pour engagement au respect des informations fournies.<br>Une fois la demande d'évaluation effectuée ces dernières ne pourront plus être modifiées.<br>Merci de suivre l'évolution de la démarche dans l'onglet 'Suivi de l'évaluation'.<br>Un rapport d'évaluation ainsi qu'une notification vous parviendra une fois l'évaluation finalisée"
                    break
                case "VALIDATED":
                    title = "Valider Projet"
                    message = "Êtes-vous sûr de vouloir valider ce projet ?"
                    break
                case "ARCHIVE":
                    title = "Archiver"
                    message = "Êtes-vous sûr de vouloir archiver ce référentiel ?"
                    break
                default:
                    title = "Remise en édition"
                    message = "Êtes-vous sûr de vouloir remettre ce référentiel en édition ?"
                    break
            }
            this.$store.commit("referential/returnConfirmationObjectMutation", { 
                id: this.selectedProject, 
                type: "referential-change-status",
                title: title,
                message: message,
                newStatus: status,
                status: this.releaseStatus,
            })
            //console.log(`Demande de changement de statut de '${this.releaseStatus}' vers '${status}'`)
        }, */
       
        getStatusLabel(referential) {
            
            let status = referential.status
            // //console.log("get status label for referential", referential.referentiel_id, referential.status, this.statusOptions)
            // //console.log("projectsAfterValidation", this.getProjectsAfterValidationList)
            // //console.log("referential in getStatusLabel", referential.referentiel_id, referential.status)
            // return status
            if (!this.statusOptions) {
                return status
            }
            if(this.statusOptions.length === 0) {
                return status
            }
            // // //console.log("projectsAfterValidation", projectsAfterValidation)
            // // //console.log("referential in getStatusLabel", referential.referentiel_id, referential.status)
            // ////console.log("this status projects", this.getProjectsAfterValidationList[referential.referentiel_id])
          /*   if(this.getProjectsAfterValidationList[referential.referentiel_id]) {
                if(status === "RELEASE" && this.getProjectsAfterValidationList[referential.referentiel_id].length > 0) {
                    //console.log("this.projectStatusByReferentialAfterValidationList : ",this.getProjectsAfterValidationList[referential.referentiel_id])
                    status = "RELEASEUSED"
                }
            } */
            const optionValue = this.statusOptions.find(opt => opt.value === status);
            return optionValue ? optionValue.label : status;
        },
        createProject() {
            this.$store.commit("referential/toggleProjectCreatorModal", { 
                open: true,
                referential_id: this.selectedReferential,
             })
            //console.log("Creating project from referential", this.canEditList)
            // this.$store.commit("project/setReferentialId", this.selectedReferential)
        },
        unlockReferential() {
            if (this.getReferentialStatus(this.selectedReferential).LOCKED && this.getReferentialStatus(this.selectedReferential).OWNER) {
                this.$store.commit("referential/returnConfirmationObjectMutation", { 
                    id: this.selectedReferential, 
                    type: "unlock-referential",
                    title: "Déverrouillage",
                    message: "Êtes-vous sûr de vouloir déverrouiller ce référentiel?"
                })
            } else {
                console.warn("Cannot unlock referential, not locked or not owner")
            }
        },
        /* canEditReferential(referentialId) {
            const status = this.getReferentialStatus(referentialId);
            if(status.READONLY) {
                return false
            }
            if(!status.LOCKED) {
                return true // If not locked, always editable
            }
            return status.OWNER && status.LOCKED // If locked, must be owner to edit
        }, */
        referentialStatus(referentialId){
            ////console.log("this.getReferentialStatus(referentialId)", this.getReferentialStatus(referentialId))
            /* if(!referentialId === this.getReferentialStatus(referentialId)) {
                return {"LOCKED": false, "OWNER": false, "READONLY": false, "EDITOR": false};
            }else { */
                return this.getReferentialStatus(referentialId);
            /* } */
        },
        goToProjectValidators() {
            //console.log("this -->", this)
            //console.log(this.filteredSortedReferentials)
            //console.log(this.filterActiveReferential[0].title)
            if(this.filterActiveReferential[0].RC) {
                this.$router.push(`/referential/${this.selectedReferential}/projects/access`)
                //console.log("Going to referential/:id/projects/access")
            }
        },
        // async changeReferentialStatus(status) {
        //     // await this.$store.dispatch("referential/referentialValidate", {
        //     //     id: this.selectedReferential
        //     // })
        //     let title = ""
        //     let message = ""
        //     // const hasBlockingError = this.referentialErrors.some(error => error.status === 'ERREUR');
        //     // // const hasErrors = this.referentialErrors && this.referentialErrors.length > 0;

        //     // if (this.referentialErrors && this.referentialErrors.length > 0) {
        //     //     title = "Le référentiel contient des erreurs";
        //     //     let formattedErrorText = "";

        //     //     for (const error of this.referentialErrors) {
        //     //         formattedErrorText += `Statut: ${error.status} \n`;
        //     //         formattedErrorText += `Paramètre: ${error.parameter}\n`;
        //     //         formattedErrorText += `Message: ${error.message}\n\n`;
        //     //     }
                
        //     //     message = formattedErrorText;
        //     //     //console.log(message);

        //     //     //console.log(title, message);
        //     //     return;
        //     // }
        //     switch (status) {
        //         case "ARCHIVE":
        //             title = "Archiver"
        //             message = "Êtes-vous sûr de vouloir archiver ce référentiel ?"
        //             break;
        //         default:
        //             title = "Remise en édition"
        //             message = "Êtes-vous sûr de vouloir remettre ce référentiel en édition ?"
        //             break;
        //     }
        //     this.$store.commit("referential/returnConfirmationObjectMutation", { 
        //         id: this.selectedReferential, 
        //         type: "referential-change-status",
        //         title: title,
        //         message: message,
        //         newStatus: status,
        //     })
        //     this.$store.commit("selectProjectMutation", 0)
        //     //console.log("Changing referential status to : ", status)
        // },
    },
};
</script>

<style scoped>


input[type="checkbox"] {
    margin-right:0.7vw;
  }

.referential-header,
.referential-item,
.referential-filter{
    display: grid;
    grid-template-columns: 22% 30% 14% 18% 17%;
    width: 100%;
    align-items: center;
}
.referential-filter{
    grid-template-columns: 60% 40%;
    margin-top: 1vh;
    color: var(--primary-light);
}
 
.referential-item:has(.actions-col) {
    grid-template-columns:28% 50% 22% ;
    margin-bottom: 1vh;
    border: 2px solid white;
    transition: all 0.2s ease;
    background-color: var(--bg-color);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

@media only screen and (min-width: 768px) and (max-width: 1400px) {
    .referential-item:has(.actions-col) {
        grid-template-columns: 28% 40% 32%;
    }
}

.referential-item:has(.projects-col) {
    grid-template-columns:28% 42% 10% 20%;
}

.referential-item:hover:has(.actions-col){
    background-color: var(--bg-color);
}

.referential-header {
    grid-template-columns: 22% 30% 14% 18% 17%;
    /* background-color: #f9f9f9; */
    font-weight: bold;
    padding: 12px 15px;
    border-radius: var(--border-radius);
    /* border-bottom: 2px solid #636262; */
    margin-bottom: 12px;
    top: 0;
}

.referential-header > div {
    cursor: pointer;
    user-select: none;
    position: relative;
}

.referential-header:hover, 
.referential-header:hover .header-filter-select{
    background-color: var(--hover-bg);
    transition: all 0.4s ease-out;
    outline:none
}


.referential-header > div:hover {
    color: var(--primary-color);
}

.referential-header > div i {
    margin-left: 5px;
}

.status-cols, .date-cols, .user-cols {
    display: grid;
    grid-template-columns: 33% 44% 23%;
    width: 100%;
}

/* column styles */
.id-col, .title-col, .description-col, .status-col, .status2-col, .date-col, .user-col, .actions-col, .projects-col{
    padding: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.projects-name {
    text-decoration: underline;
    font-weight: 700;
}

.id-col {
    text-align: center;
    font-weight: 500;
}

/* filter style */
.referential-filter {
    padding: 12px 15px;
    margin-bottom: 15px;
    background-color: #f8f9fa;
    border-radius: var(--border-radius);
    border: 1px solid var(--border-color);
    display: flex;
    justify-content: center;
}

.referential-filter {
    background-color: var(--border-color);
}

.filter-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: var(--border-radius);
    font-size: 14px;
    transition: border-color 0.2s;
}

.filter-input:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px var(--primary-light);
}

.filter-select {
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: var(--border-radius);
    background-color: white;
    cursor: pointer;
    width: 100%;
}

.date1-col, .date2-col{
    padding: 0 5px;
}

/* Status header select */
/* .status-header {
    display: flex;
    align-items: center;
position: relative;
} */

.header-filter-select {
    padding: 2px 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    width: 130px;
    height: 35px;
    border: none;
}

.header-filter-select:hover {
    outline: none;
    background-color: var(--hover-bg);
}

/* referential list */
.referential-list {
    overflow: hidden;
    background-color: #f8f9fa;
    padding:8px;
    border-radius: var(--border-radius);
}
.referential-list:has(.actions-col){
    background-color: var(--bg-color);
}

.referential-item {
    padding: 20px 4px;
    border: 2px solid #e9ecef;
    border-radius: 12px;
    cursor: pointer;
    margin-bottom: 12px;
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
    position: relative;
    overflow: hidden;
    background-color: var(--bg-color);
}

.referential-item:hover {
    background-color: var(--hover-bg);
    /* transition: border 0.2s linear; */
    transition: color 0.2s linear;
    border: 2px solid var(--primary-color);
    transition: border 0.27s ease-in;
    border-left: 7px solid var(--primary-color);
}

.criteria-container {
    padding: 20px;
    background-color: white;
    border-radius: var(--border-radius);
}

/* buttons */
.action-buttons, .filter-toggle {
    display: flex;
    justify-content: center;
    margin: 20px 0;
}

.filter-toggle-btn{
    background-color: var(--primary-light);
    color: var(--primary-color);
    border: none;
    font-size: 1rem;
}
.filter-toggle-btn:hover{
    background-color: var(--primary-color);
    color: var(--bg-color);
    border: var(--bg-color);
}
.btn {
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: 500;
}

.btn-icon {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 18px;
    padding: 0;
    margin: 0 2px;
    background-color: var(--hover-bg);
    color: var(--text-color);
}

.btn-icon:hover {
    color: var(--primary-color);
}

.actions-col {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 3vw;
    gap: 2px;
}

.referential-item.locked {
    /* cursor: not-allowed; */
    opacity: 0.65
}

.locked .locked {
    opacity: 1; 
}

div .multiselect{
    max-width: 180px;
}
:deep(.multiselect__content-wrapper){
    width: 80%;
}
:deep(.multiselect__tags){
    max-width: 80%;
}
:deep(div .multiselect){
    max-width: 45%;
}

:deep(.multiselect__option--selected.multiselect__option--highlight, .multiselect__option--selected.multiselect__option--highlight::after) {
  /* background: #ff6a6a; */
  color: #fff;
}
:deep(.multiselect__option--highlight, .multiselect__option--highlight::after) {
  /* background: var(--primary-color); */
  outline: none;
  color: #f3f3f3;
  min-width: 125%;
}

:deep(.multiselect__option--selected) {
  background: #f3f3f3;
  color: #35495e;
  font-weight: bold;
}

</style>